module.exports = __webpack_public_path__ + "img/arrow.8b3d9ef6.png";